import {Accordion, AccordionDetails, AccordionSummary, Card, Grid} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {SwitchSegmentedYesNo, TextBox} from '../../../Core/UI';
import {DatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import React from 'react';
import {observer} from 'mobx-react-lite';
import {HealthQuestionsProps} from './HealthQuestionsList';
import {Parameter} from '../../../Core/mobx/ParameterStore/ParameterStore';

const Stroke = observer(({counter, valueChanged, parameters, coreQuestions}: HealthQuestionsProps) => {
    return (
        <Accordion style={{width: '100%'}} TransitionProps={{unmountOnExit: true}}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={'stroke-content'} id={'stroke-header'}>
                <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                    <div>Stroke</div>
                    <div>{counter('stroke')}</div>
                </div>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container>
                    <Grid key="params" container>
                        {coreQuestions?.map(({name, label}) => (
                            <Grid item xs={4} key={name}>
                                <SwitchSegmentedYesNo
                                    param={{
                                        name: name,
                                        label: label,
                                        category: 'stroke',
                                        ...(parameters[name as keyof typeof parameters] as Parameter),
                                    }}
                                    required={''}
                                    valueChanged={valueChanged}
                                />
                            </Grid>
                        ))}
                        {parameters.Stroke.value && (
                            <Grid item xs={12} style={{marginTop: 10}}>
                                <Card style={{padding: 20}}>
                                    <strong>Stroke</strong>
                                    <Grid container spacing={3}>
                                        <Grid item xs={6}>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <DatePicker
                                                    inputVariant="outlined"
                                                    variant="inline"
                                                    openTo="year"
                                                    views={['year', 'month']}
                                                    label="When were you diagnosed?"
                                                    style={{width: '100%', marginTop: 8}}
                                                    value={parameters.strokeDiagnosisDate?.value || null}
                                                    onChange={(value) =>
                                                        valueChanged(parameters.strokeDiagnosisDate, value)
                                                    }
                                                />
                                            </MuiPickersUtilsProvider>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextBox
                                                label="What age was your first stroke?"
                                                value={parameters.strokeAge?.value}
                                                onChange={(value) => valueChanged(parameters.strokeAge, value)}
                                                type="number"
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextBox
                                                label="When was your last stroke?"
                                                value={parameters.strokeLastOccurence?.value}
                                                onChange={(value) =>
                                                    valueChanged(parameters.strokeLastOccurence, value)
                                                }
                                                type="number"
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <SwitchSegmentedYesNo
                                                param={{
                                                    name: 'strokeTotalOccurence',
                                                    label: 'Have you had more than one stroke?',
                                                    ...parameters.strokeTotalOccurence,
                                                }}
                                                required={''}
                                                valueChanged={valueChanged}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextBox
                                                label="What treatment was prescribed or completed for this condition? Are you currently experiencing symptoms or complications related to this condition? Provide details of your symptoms or residuals."
                                                value={parameters.strokeTreatmentSymptoms?.value}
                                                onChange={(value) =>
                                                    valueChanged(parameters.strokeTreatmentSymptoms, value)
                                                }
                                            />
                                        </Grid>
                                    </Grid>
                                </Card>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
});

export default Stroke;
